import { graphql } from '../graphql';

/**
 * Attribute-table entry point: exports a VECTOR layer (or a feature selection)
 * to SHP/DXF/DWG/GPKG as an async analysis job. Returns the synthetic batch ID.
 * Mirrors `startClipboxExport` in clipboxExport.query.ts.
 */
export const startVectorExport = graphql(`
  mutation StartVectorExport($input: StartVectorExportInput!) {
    startVectorExport(input: $input)
  }
`);
